import React from 'react';


import Typewriter from 'typewriter-effect';

import Logo from '../../../images/Logo/Logo.png';

import '../../Config/escrita.css';
import './title.css';
import '../../Config/style.css';

function Home() {
    return (
        <div className="top" id="topo">
            <a href="#section-med"> ir ao meio</a>

            <div className="logo">
                <img className="rotate-img" alt="imagem de logo" src={Logo} />
            </div>
            <div className='script-text center-text box-shadow'>
                <h1
                    className="titulo-principal dynamic-shadow" >
                    <Typewriter onInit={(typewriter) => {
                        typewriter.typeString("Adega e Trattoria Santa Helena")
                            .pauseFor(4000)
                            .deleteAll()
                            .typeString("Adega e Trattoria Santa Helena")
                            .pauseFor(4000)
                            .start();
                    }}
                    />
                </h1>
            </div>
        </div>
    );
}

export default Home;